import * as THREE from 'three';
import {Howl, Howler} from 'howler';
import {
    fsFragmentDisplacement,
    fsCustomAttributesAndUniforms
} from './glsl/CustomChunks';

let scene, renderer, camera, textureLoader;
let cameraController, cameraTarget;
let renderHandler, resizeHandler, canvas, clock, time;
let light, ambient;
let planeMaterial, planeGeometry, environmentMap;
let w, h;
let sound, analyser, bufferLength, dataArray, totalChannels;
let canvas2d, canvasCtx, canvasTexture, currentTexture = 0;
const textures = [];

import * as dat from 'dat.gui';

export default class Main {
    constructor(canvas2d) {
        canvas = canvas2d;

        renderHandler = this.render.bind(this);
        resizeHandler = this.resize.bind(this);

        this.setupAudio();
        this.setup();
        this.addEvents();
        this.resize();
        this.render();
    }

    setup(){
        textureLoader           = new THREE.TextureLoader();
        scene                   = new THREE.Scene();
        camera                  = new THREE.PerspectiveCamera(60, window.innerWidth/window.innerHeight, 1, 100);
        renderer                = new THREE.WebGLRenderer({
            antialias: true,
            canvas: canvas
        });
        // renderer.outputEncoding = THREE.sRGBEncoding;
        light                   = new THREE.DirectionalLight();
        ambient                 = new THREE.AmbientLight(0x696969);
        clock                   = new THREE.Clock();

        renderer.setClearColor(0xFFFFFF);
        scene.add(ambient);
        scene.add(light);
        clock.start();

        camera.position.z = 12;

        if (navigator.requestMIDIAccess) {
            console.log('This browser supports WebMIDI!');
            navigator.requestMIDIAccess().then( this.onMIDISuccess, () => this.onMIDIFailure);

        } else {
            console.log('WebMIDI is not supported in this browser.');
        }

        this.setupPlane();
        window.uniforms = {
            uChannelR: 0.01,
            uChannelG: 0.011,
            uChannelB: 0.012,
            uScale: 1,
            texture: 0
        };
        //this.setupDatGui();
    }

    onMIDISuccess(midiAccess) {
        console.log(midiAccess);
    
        var inputs = midiAccess.inputs;
        var outputs = midiAccess.outputs;
        for (var input of inputs.values())
            input.onmidimessage = (midiMessage)=>{
                console.log(midiMessage.currentTarget.id, midiMessage.data);
                const v = midiMessage.data[2] / 127;
                const vn = v * 2 - 1;
                switch(midiMessage.data[1]){
                    case 1 :
                        window.uniforms.uScale = v * 3;
                        break;
                    case 2 :
                        window.uniforms.uChannelR = vn * 0.03;
                        break;
                    case 3 :
                        window.uniforms.uChannelG = vn * 0.03;
                        break;
                    case 4 :
                        window.uniforms.uChannelB = vn * 0.03;
                        break;
                    case 5 :
                        break;
                    case 6 :
                        break;
                    case 7 :
                        break;
                    case 8 :
                        break;
                }
            };
    }
    
    onMIDIFailure() {
        console.log('Could not access your MIDI devices.');
    }

    getMIDIMessage(midiMessage) {
        console.log(midiMessage);
    }

    setupDatGui(){
    
        this.gui = new dat.GUI();
        this.gui.useLocalStorage = true;
        const folder1 = this.gui.addFolder('Presets');
        folder1.add(window.uniforms, "uChannelR", -0.03, 0.03);
        folder1.add(window.uniforms, "uChannelG", -0.03, 0.03);
        folder1.add(window.uniforms, "uChannelB", -0.03, 0.03);
        folder1.add(window.uniforms, "uScale", 0, 3);
        folder1.add(window.uniforms, "texture",  { 
            texture1: 0, 
            texture2: 1,
            texture3: 2,
            texture4: 3,
            texture5: 4,
            texture6: 5}).onChange((e)=>{
                console.log(e);
                planeMaterial.map = textures[e];
            });
    }

    onClick() {
        if(!sound.playing()){
            sound.play();
            console.log("playing sound!");
        } else {
            sound.pause();
            console.log("pause sound!");
        }
    }

    addEvents() {
        window.addEventListener('resize', resizeHandler);

        sound.on("play", ()=>{
            let context = sound._sounds[0]._node.context;           
            let src = sound._sounds[0]._node.bufferSource;
            analyser = context.createAnalyser(); 
            src.connect(analyser); 
            analyser.fftSize = totalChannels; 
            bufferLength = analyser.frequencyBinCount; 
            dataArray = new Uint8Array(bufferLength);
            analyser.getByteFrequencyData(dataArray);
        });
    }

    setupAudio(){
        totalChannels = 512;
        sound = new Howl({
            src: ['assets/audio/harisima_cielorojo.mp3'],
            autoplay: false,
            preload: true,
            loop: true,
            volume: 1,
            onend: function() {
                console.log('Finished!');
            }
        });
        canvas2d = document.createElement("canvas");
        canvas2d.style.position = "absolute";
        canvas2d.width = totalChannels * 0.5;
        canvas2d.height = 2;
        canvas2d.style.top = "0";
        canvas2d.style.width = totalChannels * 0.5 + "px";
        canvas2d.style.height = "2px";
        canvasCtx = canvas2d.getContext("2d");
        //document.body.appendChild(canvas2d);

        canvasTexture = new THREE.CanvasTexture(canvas2d);
        canvasTexture.magFilter = THREE.LinearFilter;
        canvasTexture.minFilter = THREE.LinearFilter;
        canvasTexture.needsUpdate = true;
    }
    setupPlane() {
        planeGeometry = new THREE.PlaneBufferGeometry(38.4, 21.6, 2, 2);

        textures[0] = textureLoader.load('assets/textures/__scan.jpg');
        planeMaterial = new THREE.MeshBasicMaterial({
            map: textures[0]
        });

        planeMaterial.userData.uTime = { value : 0 };
        planeMaterial.userData.uCanvasTexture = { value : canvasTexture };
        planeMaterial.userData.uAmplitude = { value : new THREE.Vector3() };
        planeMaterial.userData.uScale = { value : 1 };
        planeMaterial.onBeforeCompile = shader => {
            shader.uniforms.uTime = planeMaterial.userData.uTime;
            shader.uniforms.uAmplitude = planeMaterial.userData.uAmplitude;
            shader.uniforms.uScale = planeMaterial.userData.uScale;
            shader.uniforms.uCanvasTexture = planeMaterial.userData.uCanvasTexture;

            shader.fragmentShader = fsCustomAttributesAndUniforms + shader.fragmentShader;
            shader.fragmentShader = shader.fragmentShader.replace(
                '#include <map_fragment>', fsFragmentDisplacement
            );
        }

        const mesh = new THREE.Mesh(planeGeometry, planeMaterial);
        scene.add(mesh);
    }

    resize(e) {
        w = window.innerWidth;
        h = window.innerHeight;
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(w, h);
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
    }

    render(){
        requestAnimationFrame(renderHandler);
        time = clock.getElapsedTime();
        renderer.render(scene, camera);
        this.update();
    }

    update(){
        if(planeMaterial){
            planeMaterial.userData['uTime'].value = time;
            planeMaterial.userData['uAmplitude'].value.set(
                window.uniforms.uChannelR,
                window.uniforms.uChannelG,
                window.uniforms.uChannelB
            );
            planeMaterial.userData['uScale'].value = window.uniforms.uScale;
            planeMaterial.userData['uCanvasTexture'].value.needsUpdate = true;
        }
        if(analyser) {
            analyser.getByteFrequencyData(dataArray);
            this.drawCanvas(dataArray, canvasCtx);
        }

        let timeTexture =  Math.floor(time) % textures.length;
        if( timeTexture != currentTexture){
            planeMaterial.map = textures[timeTexture];
            currentTexture = timeTexture;
        }
    }

    drawCanvas(dataArray, canvasCtx) {
        //Draw black background
        canvasCtx.fillStyle = 'rgb(0, 0, 0)';
        canvasCtx.fillRect(0, 0, canvas2d.width, canvas2d.height);
        const bufferLength = analyser.frequencyBinCount;
        //Draw spectrum
        const barWidth = (canvas2d.width / bufferLength) * 2;
        const halfWidth = barWidth * 0.5;
        let posX = 0;
        let v = 0;
        for (let i = 0; i < bufferLength; i++) {
            const barHeight = (dataArray[i]) + 0;
            v += dataArray[i];
            canvasCtx.fillStyle = 'rgb(' + barHeight + ',' + barHeight + ','+ barHeight + ')';
            canvasCtx.fillRect(posX, 0, barWidth, 2);
            posX += barWidth;
        }
        v/=bufferLength;
    }
}